function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M27.3 4.7C24.3 1.7 20.3 0 16 0C11.7 0 7.7 1.7 4.7 4.7C1.7 7.7 0 11.7 0 16C0 20.3 1.7 24.3 4.7 27.3C7.7 30.3 11.7 32 16 32C20.3 32 24.3 30.3 27.3 27.3C30.3 24.3 32 20.3 32 16C32 11.7 30.3 7.7 27.3 4.7ZM28.2 22.9L23.7 18.4C24.2 16.9 24.2 15.2 23.7 13.7L28.2 9.2C29.4 11.3 30 13.6 30 16.1C30 18.6 29.4 20.8 28.2 22.9ZM18.3 21.6C17.5 21.8 16.8 22 16 22C15.2 22 14.5 21.8 13.7 21.6C13 21.3 12.3 20.9 11.7 20.3C9.4 18 9.4 14.2 11.7 11.8C12.3 11.2 13 10.8 13.7 10.5C14.4 10.2 15.2 10.1 16 10.1C16.8 10.1 17.5 10.3 18.3 10.5C19 10.8 19.7 11.2 20.3 11.8C22.6 14.1 22.6 17.9 20.3 20.3C19.7 20.8 19 21.3 18.3 21.6ZM22.9 3.8L18.4 8.3C17.6 8.1 16.8 8 16 8C15.2 8 14.4 8.1 13.6 8.4L9.1 3.8C11.2 2.6 13.5 2 16 2C18.5 2 20.8 2.6 22.9 3.8ZM3.8 9.1L8.3 13.6C7.8 15.1 7.8 16.8 8.3 18.3L3.8 22.8C2.6 20.8 2 18.5 2 16C2 13.5 2.6 11.2 3.8 9.1ZM9.1 28.2L13.6 23.7C14.4 23.9 15.2 24.1 16 24.1C16.8 24.1 17.6 24 18.4 23.7L22.9 28.2C20.8 29.4 18.5 30 16 30C13.5 30 11.2 29.4 9.1 28.2Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.53166d95105050fc2a75c8580a987c58.svg";
export { ForwardRef as ReactComponent };